import PropTypes from 'prop-types'
import styled from 'styled-components'

import colors from 'components/utils/colors'

const StyledWrapper = styled.div`
  color: ${colors.secondary70};
  font-size: 14px;
  height: 32px;
  line-height: 32px;
  vertical-align: middle;
  padding-left: 8px;
`

const LoadingMessage = (props) => {
  return (
    <StyledWrapper>
      {props.selectProps.loadingMessage()}
    </StyledWrapper>
  )
}

LoadingMessage.propTypes = {
  selectProps: PropTypes.object,
}

export default LoadingMessage
